import type { BackgroundMediaController } from "../hooks/useBackgroundMedia";
import { Icon } from "./Icon";

type SoundControlProps = {
  readonly media: BackgroundMediaController;
};

export function SoundControl({ media }: SoundControlProps) {
  const isUnavailable = !media.enabled || media.state === "unavailable";
  const soundLabel = isUnavailable
    ? "Background audio unavailable"
    : media.isMuted
      ? "Turn background sound on"
      : "Mute background sound";

  return (
    <div
      className={`flex h-10 items-center rounded-full border bg-surface/35 p-1 backdrop-blur-md transition-colors ${
        media.isMuted
          ? "border-ink/15 text-ink/50"
          : "border-accent/35 text-ink"
      } ${isUnavailable ? "opacity-40" : ""}`}
    >
      <button
        className="grid size-8 shrink-0 cursor-pointer place-items-center rounded-full border-0 bg-transparent transition-colors hover:bg-ink/10 disabled:cursor-default"
        type="button"
        onClick={() => void media.toggleSound()}
        disabled={isUnavailable}
        aria-label={soundLabel}
      >
        <span className="size-4">
          <Icon name={media.isMuted ? "mute" : "sound"} />
        </span>
      </button>

      <input
        className={`sound-range mr-2 ml-1 w-[74px] max-[620px]:w-[58px] ${
          media.isMuted ? "opacity-45" : "opacity-100"
        }`}
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={media.volume}
        onChange={(event) => void media.setVolume(Number(event.target.value))}
        disabled={isUnavailable}
        aria-label="Background volume"
      />
    </div>
  );
}
